import { Action } from 'infra/types'
import { PushPermission } from './realtime.state'

export const RealtimeActions = {
  /** Kick off realtime push setup for a business (dispatched on business select). */
  INIT_REALTIME_SYNC: 'realtime/init',
  SET_PUSH_SUPPORTED: 'realtime/setSupported',
  SET_PUSH_PERMISSION: 'realtime/setPermission',
  SHOW_PUSH_NUDGE: 'realtime/showNudge',
  DISMISS_PUSH_NUDGE: 'realtime/dismissNudge',
  /** User accepted the nudge — request permission + register token. */
  ACCEPT_PUSH_NUDGE: 'realtime/acceptNudge',
  SET_PUSH_REGISTERED: 'realtime/setRegistered'
}

export const initRealtimeSync = (payload: {
  businessId: string
}): Action<{ businessId: string }> => ({
  type: RealtimeActions.INIT_REALTIME_SYNC,
  payload
})

export const setPushSupported = (supported: boolean): Action<boolean> => ({
  type: RealtimeActions.SET_PUSH_SUPPORTED,
  payload: supported
})

export const setPushPermission = (permission: PushPermission): Action<PushPermission> => ({
  type: RealtimeActions.SET_PUSH_PERMISSION,
  payload: permission
})

export const showPushNudge = (): Action<null> => ({
  type: RealtimeActions.SHOW_PUSH_NUDGE,
  payload: null
})

export const dismissPushNudge = (): Action<null> => ({
  type: RealtimeActions.DISMISS_PUSH_NUDGE,
  payload: null
})

export const acceptPushNudge = (): Action<null> => ({
  type: RealtimeActions.ACCEPT_PUSH_NUDGE,
  payload: null
})

export const setPushRegistered = (payload: {
  deviceId: string | null
}): Action<{ deviceId: string | null }> => ({
  type: RealtimeActions.SET_PUSH_REGISTERED,
  payload
})
